import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { cx, ui } from '@wp-g2/styles';
import React from 'react';
import { View } from '../View';
import * as styles from './Switch.styles';

function SwitchBackdrop(_ref) {
  var className = _ref.className,
      error = _ref.error,
      _ref$isFocused = _ref.isFocused,
      isFocused = _ref$isFocused === void 0 ? false : _ref$isFocused,
      props = _objectWithoutProperties(_ref, ["className", "error", "isFocused"]);

  var classes = cx(styles.Backdrop, isFocused && styles.focus, error && styles.backdropError, error && isFocused && styles.backdropErrorFocus, className);
  return /*#__PURE__*/React.createElement(View, Object.assign({
    "aria-hidden": true
  }, ui.$('SwitchBackdrop'), props, {
    className: classes
  }));
}

export default /*#__PURE__*/React.memo(SwitchBackdrop);